import { useEffect } from 'react'

import { applyStatusBarTone, type StatusBarTone } from '../services/status-bar.ts'

/** Sets the status bar to the ground the page is on, and again when it changes. A refusal is
 *  not worth a screen: the bar is a courtesy, and the page reads fine without it. */
export function useStatusBarTone(tone: StatusBarTone): void {
  useEffect(() => {
    applyStatusBarTone(tone).catch(() => undefined)
  }, [tone])
}
